import { FC, useEffect } from 'react';
import { Helmet } from 'react-helmet';

import { AuthModal } from 'interfaces/auth';

import { useAuthModalsContext } from 'components/AuthModals';

export const LoginPage: FC = () => {
  const { isModalOpened, setIsModalOpened, setAuthModal } = useAuthModalsContext();

  useEffect(() => {
    if (isModalOpened) return;

    setAuthModal(AuthModal.LOGIN);
    setIsModalOpened(true);
  }, [isModalOpened]);

  return (
    <>
      <Helmet>
        <script type="text/javascript" defer>
          {`
            window.dataLayer = window.dataLayer || [];
            let userId = '';
            try {
              const userStore = localStorage.getItem('user-store');
              if (userStore) {
                const parsed = JSON.parse(userStore);
                userId = parsed?.state?.authUser?.id || '';
                dataLayer.push({ user_id: userId });
              }
            } catch (e) {
              console.error('Failed to parse user-store:', e);
            }
          `}
        </script>
      </Helmet>
    </>
  );
};
